import useStyles from './Header.styles';
import ProfileButton from '../Profile/ProfileButton';
import { UseStylesProps } from 'types/utils/UseStylesProps';
import ChannelLinkSelect from '../ChannelLink/ChannelLinkSelect';
import { Container, Grid } from '@mui/material';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import MobileHeader from 'mobile/App/MobileHeader';
import { useSelectedLinkContext } from 'contexts';
import { isSelfLink } from 'utils/link';

type HeaderPureProps = UseStylesProps;

const HeaderPure = ({ classes }: HeaderPureProps): JSX.Element => (
  <Container>
    <div className={classes.container}>
      <Grid alignItems="center" className={classes.profileContainer} container>
        <Grid className={classes.gridItem} item md={8} xs={12}>
          <ChannelLinkSelect />
        </Grid>
        <Grid className={classes.gridItem} item md={4} xs={12}>
          <ProfileButton />
        </Grid>
      </Grid>
    </div>
  </Container>
);

const Header = (): JSX.Element | null => {
  const classes = useStyles();
  const isSmallScreen = useSmallDesktopScreen();
  const { selectedLink } = useSelectedLinkContext();

  if (isSelfLink(selectedLink)) {
    return null;
  } else if (isSmallScreen) {
    return <MobileHeader classes={classes} />;
  }

  return <HeaderPure classes={classes} />;
};

export default Header;
